import { useState, useEffect } from "react";

const API = "http://54.89.187.167:8000";

export default function App() {
  const [files, setFiles] = useState([]);
  const [platePreview, setPlatePreview] = useState([]);
  const [jobId, setJobId] = useState(null);
  const [status, setStatus] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [running, setRunning] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!jobId || status === "complete" || status === "failed") return;
    const interval = setInterval(async () => {
      const res = await fetch(`${API}/job/${jobId}/status`);
      const data = await res.json();
      setStatus(data.status);
      if (data.status === "complete" || data.status === "failed") {
        setRunning(false);
        clearInterval(interval);
      }
    }, 10000);
    return () => clearInterval(interval);
  }, [jobId, status]);

  const handleFolderChange = (e) => {
    const allFiles = Array.from(e.target.files);
    const mp4Files = allFiles.filter(f => f.name.toLowerCase().endsWith(".mp4"));

    // Group by immediate parent folder name (plate folder) for the preview
    const groups = {};
    mp4Files.forEach(f => {
      const parts = f.webkitRelativePath.split("/");
      const plateFolder = parts.length >= 3 ? parts[1] : parts[0];
      groups[plateFolder] = (groups[plateFolder] || 0) + 1;
    });

    setFiles(mp4Files);
    setPlatePreview(Object.entries(groups));
    setJobId(null);
    setStatus(null);
    setError(null);
  };

  const handleUpload = async () => {
    if (files.length === 0) return;
    setUploading(true);
    setError(null);
    try {
      const form = new FormData();
      files.forEach(f => {
        form.append("files", f);
        form.append("paths", f.webkitRelativePath);
      });
      const res = await fetch(`${API}/upload_folder`, { method: "POST", body: form });
      const data = await res.json();
      if (data.job_id) {
        setJobId(data.job_id);
        setStatus("pending");
      } else {
        setError("Upload failed: " + JSON.stringify(data));
      }
    } catch (e) {
      setError("Upload error: " + e.message);
    }
    setUploading(false);
  };

  const handleRun = async () => {
    if (!jobId) return;
    setRunning(true);
    setError(null);
    try {
      const res = await fetch(`${API}/job/${jobId}/run`, { method: "POST" });
      const data = await res.json();
      setStatus(data.status);
    } catch (e) {
      setError("Run error: " + e.message);
      setRunning(false);
    }
  };

  const handleDownload = () => {
    window.open(`${API}/job/${jobId}/download`, "_blank");
  };

  return (
    <div style={{ maxWidth: 640, margin: "60px auto", fontFamily: "sans-serif", padding: 24 }}>
      <h1 style={{ fontSize: 28, fontWeight: 600, marginBottom: 4 }}>CytoMotion</h1>
      <p style={{ color: "#666", marginBottom: 32 }}>Cardiac contractility analysis pipeline</p>

      <div style={{ background: "#f9f9f9", border: "1px solid #ddd", borderRadius: 8, padding: 24, marginBottom: 16 }}>
        <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>1. Select Experiment Folder</h2>
        <p style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>
          Select the experiment folder (e.g. CP011_20250613_D49). It should contain Plate_* subfolders with MP4 files.
        </p>
        <input
          type="file"
          webkitdirectory=""
          directory=""
          onChange={handleFolderChange}
          style={{ marginBottom: 12, display: "block" }}
        />

        {platePreview.length > 0 && (
          <div style={{ marginBottom: 12, padding: 12, background: "#e8f4fd", borderRadius: 6 }}>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6, color: "#0066cc" }}>
              Detected {platePreview.length} plate(s):
            </div>
            {platePreview.map(([plate, count]) => (
              <div key={plate} style={{ fontSize: 12, color: "#444" }}>
                📁 {plate} — {count} video(s)
              </div>
            ))}
          </div>
        )}

        <button
          onClick={handleUpload}
          disabled={files.length === 0 || uploading || !!jobId}
          style={{ background: "#0066cc", color: "#fff", border: "none", borderRadius: 6, padding: "10px 20px", cursor: "pointer", opacity: (files.length === 0 || uploading || !!jobId) ? 0.5 : 1 }}
        >
          {uploading ? "Uploading..." : "Upload"}
        </button>
      </div>

      {jobId && (
        <div style={{ background: "#f9f9f9", border: "1px solid #ddd", borderRadius: 8, padding: 24, marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>2. Run Analysis</h2>
          <p style={{ fontSize: 13, color: "#666", marginBottom: 12 }}>Job ID: {jobId}</p>
          <button
            onClick={handleRun}
            disabled={status !== "pending" || running}
            style={{ background: "#28a745", color: "#fff", border: "none", borderRadius: 6, padding: "10px 20px", cursor: "pointer", opacity: (status !== "pending" || running) ? 0.5 : 1 }}
          >
            {running ? "Starting..." : "Run Analysis"}
          </button>
        </div>
      )}

      {status && (
        <div style={{ background: "#f9f9f9", border: "1px solid #ddd", borderRadius: 8, padding: 24, marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>3. Status</h2>
          <div style={{
            display: "inline-block", padding: "6px 16px", borderRadius: 20, fontWeight: 600, fontSize: 14,
            background: status === "complete" ? "#d4edda" : status === "failed" ? "#f8d7da" : status === "running" ? "#fff3cd" : "#e2e3e5",
            color: status === "complete" ? "#155724" : status === "failed" ? "#721c24" : status === "running" ? "#856404" : "#383d41"
          }}>
            {status === "running" ? "⏳ Running — check back in ~8 minutes" : status === "complete" ? "✅ Complete" : status === "failed" ? "❌ Failed" : "⏸ Pending"}
          </div>
        </div>
      )}

      {status === "complete" && (
        <div style={{ background: "#f9f9f9", border: "1px solid #ddd", borderRadius: 8, padding: 24, marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>4. Download Results</h2>
          <button
            onClick={handleDownload}
            style={{ background: "#6f42c1", color: "#fff", border: "none", borderRadius: 6, padding: "10px 20px", cursor: "pointer" }}
          >
            Download Results (ZIP)
          </button>
        </div>
      )}

      {error && (
        <div style={{ background: "#f8d7da", border: "1px solid #f5c6cb", borderRadius: 8, padding: 16, color: "#721c24" }}>
          {error}
        </div>
      )}
    </div>
  );
}